<template>
  <div class="row mb-32">
    <div
      class="col-6 col-xl-4 d-flex align-items-center justify-content-center"
    >
      <BaseUserProfilePicture :user-pic="img" :user-pic-type="'login'" />
    </div>
    <div class="col-6 col-xl-8 p-0">
      <p class="mb-1 mt-3 text-primary text-small">
        {{ greeting }}
      </p>
      <h4 class="mb-0">
        {{ name }}
      </h4>
      <p v-if="email" class="text-muted">
        {{ email }}
      </p>
    </div>
  </div>
</template>

<script>
import BaseUserProfilePicture from './BaseUserProfilePicture'

export default {
  components: {
    BaseUserProfilePicture,
  },
  props: {
    greeting: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      default: '',
    },
    img: {
      type: String,
      default: 'https://via.placeholder.com/150',
    },
    onSubmit: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
.text-muted {
  overflow-wrap: break-word;
}

.login {
  display: flex;
  justify-content: center;
}
</style>
